import { AfterViewInit, Component, OnInit } from '@angular/core';
import { trigger, style, transition, animate } from '@angular/animations';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { InvoiceService } from 'src/app/services/invoice/invoice.service';
import { Invoice } from 'src/app/shared/models/invoice.interface';
import { PaginatedResponse, PaginationInfo } from 'src/app/shared/models';
import { MashoManagerModalService } from 'src/app/services/masho-manager-modal/masho-manager-modal.service';
import { ShipService } from 'src/app/services/ship/ship.service';
import { ClientService } from 'src/app/services/user/client.service';
import { UserService } from 'src/app/services/user/user.service';
import { GlobalStateService } from 'src/app/services/global/global-state.service';
import { PortService } from 'src/app/services/port/port.service';
import { VendorService } from 'src/app/services/vendor/vendor.service';
import { GeneralService } from 'src/app/services/general/general.service';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { HelperService } from 'src/app/services/helper/helper.service';
import { Router } from '@angular/router';
declare var KTMenu: any;
declare var bootstrap: any;
// Define filter interface
interface ShippingFilters {
  stock_number?: string;
  chassis_no?: string;
  auction_hall?: string;
  lot_number?: string;
  yard_in_date_from?: string;
  yard_in_date_to?: string;
  purchase_date_from?: string;
  purchase_date_to?: string;
  sailing_from_date?: string;
  sailing_to_date?: string;
  arrival_from_date?: string;
  arrival_to_date?: string;
  ship_type?: string;
  ship_name?: any;
  carrier_name?: string;
  voyage_no?: string;
  search_client?: any;
  sales_person?: any;
  sailing_port?: string;
  destination_country?: string;
  destination_country_label?: string;
  destination_port?: string;
  yard?: string;
  ship_name_id?: string;
  search_client_id?: string;
  sales_person_id?: string;
}

@Component({
  selector: 'app-shipping',
  templateUrl: './shipping.component.html',
  styleUrls: ['./shipping.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ height: '0px', opacity: 0, overflow: 'hidden' }),
        animate('300ms ease-in-out', style({ height: '*', opacity: 1 }))
      ]),
      transition(':leave', [
        style({ height: '*', opacity: 1, overflow: 'hidden' }),
        animate('300ms ease-in-out', style({ height: '0px', opacity: 0 }))
      ])
    ])
  ]
})
export class ShippingComponent extends DestructorComponent implements OnInit, AfterViewInit {
  // Data properties
  invoices: Invoice[] = [];
  paginationInfo: PaginationInfo = {
    currentPage: 1,
    perPage: 20,
    total: 0,
    lastPage: 1,
    firstPage: 1
  };

  // State properties
  isLoading: boolean = false;
  isExportingExcel: boolean = false;
  isExportingSelectedFields: boolean = false;
  isSendingMail: boolean = false;
  searchTerm: string = '';
  currentPage: number = 1;
  selectedStatus: string = 'not_yet';
  private searchTimeout: any;
  selectedSubFilter: string = '';
  showSubFilters: boolean = false;
  selectedFreightPaidSubFilter: string = '';

  // Filter properties
  showFilters: boolean = false;
  filters: ShippingFilters = {};

  currentDate:any = new Date();

  // Ship search properties
  shipSearchTerm: string = '';
  selectedShip: any = null;
  shipSearchResults: any[] = [];
  showShipDropdown: boolean = false;
  isShipSearching: boolean = false;
  private shipSearchSubject = new Subject<string>();

  // Client search properties
  clientSearchTerm: string = '';
  selectedClient: any = null;
  clientSearchResults: any[] = [];
  showClientDropdown: boolean = false;
  isClientSearching: boolean = false;
  private clientSearchSubject = new Subject<string>();

  // Sales person search properties
  salesPersonSearchTerm: string = '';
  selectedSalesPerson: any = null;
  salesPersonSearchResults: any[] = [];
  showSalesPersonDropdown: boolean = false;
  isSalesPersonSearching: boolean = false;
  private salesPersonSearchSubject = new Subject<string>();

  // Countries and ports
  countries: any[] = [];
  ports: any[] = [];
  yards: any[] = [];
  isLoadingPorts: boolean = false;
  // Multi-row editing properties
  hasChanges: boolean = false;
  changedRows: any[] = [];
  formData: { [invoiceId: string]: any } = {};

  // Invoice selection properties
  selectedInvoices: Set<string> = new Set();
  selectedPdfFormat: string = '';
  showPdfOptions: boolean = false;

  // Checkbox selection for ISL copy
  selectedInvoicesForCopy: string[] = [];

  // Available PDF formats
  pdfFormats = [
    { value: 'plain_invoice', label: 'Imperial Solutions Format' },
    { value: 'caricom_invoice', label: 'Caricom Invoice Format' },
    { value: 'commercial_invoice', label: 'Commercial Invoice Format' },
    { value: 'standard_invoice', label: 'Standard Invoice Format' },
    { value: 'shipping_information', label: 'Shipping Information Format' },
    { value: 'export_certificate', label: 'Export Certificate Format' },
    { value: 'house_bill_landing', label: 'House Bill of Lading Format' }
  ];

  // Document types for email
  documentTypes = [
    { value: 'plain_invoice', label: 'Invoice' },
    { value: 'caricom_invoice', label: 'Caricom Invoice' },
    { value: 'commercial_invoice', label: 'Commercial Invoice' },
    { value: 'shipping_information', label: 'Shipping Instruction' },
    { value: 'vehicle-certificate-invoice', label: 'Export Certificate' },
    { value: 'ctn_invoice', label: 'CTN Invoice' },
    { value: 'ctn_invoice_excel', label: 'CTN Invoice Excel' }
  ];

  // Selected document types for email
  selectedDocumentTypes: string[] = [];

  // Available status options for tabs
  statusOptions = [
    { value: 'not_yet', label: 'Not Yet' },
    {
      value: 'pending', label: 'Pending', showShipTypes: true, shipTypes:
        [
          { value: 'roro', label: 'Roro' },
          { value: 'container', label: 'Container' },
          { value: 'ckd', label: 'CKD' }
        ]
    },
    { value: 'tentative', label: 'Tentative' },
    { value: 'confirmed', label: 'Confirmed' },
    { value: 'freight_unpaid', label: 'Freight Unpaid' },
    {
      value: 'freight_paid', label: 'Freight Paid', freightPaidTypes:
        [
          { value: 'fob', label: 'FOB' },
          { value: 'cnf', label: 'C&F' }
        ]
    }
  ];

  constructor(
    private invoiceService: InvoiceService,
    private _mashoManagerModalService: MashoManagerModalService,
    private shipService: ShipService,
    private clientService: ClientService,
    private userService: UserService,
    private helperService: HelperService,
    private globalStateService: GlobalStateService,
    private portService: PortService,
    private _router:Router,
    private vendorService: VendorService,
    private generalService: GeneralService
  ) {
    super();
    this.setupShipSearchDebounce();
    this.setupClientSearchDebounce();
    this.setupSalesPersonSearchDebounce();
  }

  onSubFilterSelect(subFilter: string, type: string = ''): void {
    this.selectedSubFilter = type ? '' : subFilter;
    this.selectedStatus = type ? type : 'pending';
    this.selectedFreightPaidSubFilter = type ? subFilter : '';
    this.loadInvoices(1, this.searchTerm, { shipping_status: this.selectedStatus, ship_type: this.selectedSubFilter, freight_paid_type: this.selectedFreightPaidSubFilter });
  }

  ngOnInit(): void {
    this.loadInvoices(1, '', { shipping_status: 'not_yet' });
    this.loadCountries();
    this.loadYards();
  }

  ngAfterViewInit(): void {
    // Don't initialize DataTables since we're using Angular for data management
    // this.datatableService.init('kt_table_invoices');

    // Initialize menus after view is initialized
    this.initializeMenus();
  }

  loadInvoices(page: number = 1, search: string = '', filters: Record<string, any> = {}): void {
    this.isLoading = true;
    this.currentPage = page;

    let search_filters = {...filters};
    delete search_filters.search_client;
    delete search_filters.ship_name;

    this.subscriptions.push(
      this.invoiceService.GetData(page.toString(), search, search_filters).subscribe({
        next: (response: PaginatedResponse<Invoice>) => {
          if (response.status && response.data) {
            this.invoices = response.data.data || [];
            this.paginationInfo = response.data.pagination;
            this.currentPage = response.data.pagination.currentPage;
            this.currentDate = response.data.pagination.currentDate;
            // Initialize form data for new invoices
            this.initializeFormData();
          } else {
            this.invoices = [];
            this.resetPagination();
          }
          this.isLoading = false;
          // Initialize KTMenu instances after data is loaded
          this.refreshMenus();
        },
        error: (error) => {
          console.error('Error loading invoices:', error);
          this.invoices = [];
          this.resetPagination();
          this.isLoading = false;
          // Initialize KTMenu instances even on error
          this.refreshMenus();
        }
      })
    );
  }

  private resetPagination(): void {
    this.paginationInfo = {
      currentPage: 1,
      perPage: 20,
      total: 0,
      lastPage: 1,
      firstPage: 1
    };
  }

  onPageChange(page: number): void {
    this.loadInvoices(page, this.searchTerm);
  }

  onSearch(searchTerm: string): void {
    this.searchTerm = searchTerm;
    this.loadInvoices(1, searchTerm);
  }

  onSearchInput(event: Event): void {
    const target = event.target as HTMLInputElement;

    // Clear previous timeout
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    // Debounce search by 300ms
    this.searchTimeout = setTimeout(() => {
      this.onSearch(target.value);
    }, 300);
  }

  onStatusFilter(filterValue: string): void {
    this.selectedStatus = filterValue;
    const filters: Record<string, any> = {};

    // Find the selected option
    const selectedOption = this.statusOptions.find(option => option.value === filterValue) as any;

    if (selectedOption) {

      filters['shipping_status'] = filterValue;

    }

    this.selectedSubFilter = '';

    this.loadInvoices(1, this.searchTerm, filters);
  }



  onResetFilters(): void {
    this.searchTerm = '';
    this.selectedStatus = 'not_yet';
    this.loadInvoices(1, '', { shipping_status: 'not_yet' });
  }

  // Invoice selection methods
  onInvoiceSelect(invoiceId: string, event: any): void {
    if (event.target.checked) {
      this.selectedInvoices.add(invoiceId);
    } else {
      this.selectedInvoices.delete(invoiceId);
    }
    this.updatePdfOptionsVisibility();
  }

  onSelectAll(event: any): void {
    if (event.target.checked) {
      this.invoices.forEach(invoice => this.selectedInvoices.add(invoice._id));
    } else {
      this.selectedInvoices.clear();
    }
    this.updatePdfOptionsVisibility();
  }

  isInvoiceSelected(invoiceId: string): boolean {
    return this.selectedInvoices.has(invoiceId);
  }

  isAllSelected(): boolean {
    return this.invoices.length > 0 && this.selectedInvoices.size === this.invoices.length;
  }

  isIndeterminate(): boolean {
    return this.selectedInvoices.size > 0 && this.selectedInvoices.size < this.invoices.length;
  }

  private updatePdfOptionsVisibility(): void {
    this.showPdfOptions = this.selectedInvoices.size > 0;
    if (!this.showPdfOptions) {
      this.selectedPdfFormat = '';
    }
  }

  onPdfFormatChange(): void {
    // Format selection changed - could trigger preview or other actions
    console.log('Selected format:', this.selectedPdfFormat);
  }

  onPreviewPdf(): void {
    if (this.selectedInvoices.size === 0 || !this.selectedPdfFormat) {
      return;
    }

    const selectedInvoiceIds = Array.from(this.selectedInvoices);
    const selectedInvoiceData = this.invoices.filter(invoice =>
      selectedInvoiceIds.includes(invoice._id)
    );

    // Set the modal data - Bootstrap will handle opening the modal
    this.selectedInvoicesForModal = selectedInvoiceData;
    this.selectedFormatForModal = this.selectedPdfFormat;

    console.log('Modal data prepared:', {
      invoices: this.selectedInvoicesForModal.length,
      format: this.selectedFormatForModal
    });
  }

  // Modal integration properties
  selectedInvoicesForModal: Invoice[] = [];
  selectedFormatForModal: string = '';

  // Invoice detail modal properties
  selectedInvoiceForDetail: Invoice | null = null;
  selectedInvoiceIdForDetail: string = '';



  getSelectedCount(): number {
    return this.selectedInvoices.size;
  }

  onClearSelection(): void {
    this.selectedInvoices.clear();
    this.updatePdfOptionsVisibility();
  }

  // Helper methods for displaying data
  formatDate(dateString: string | null | undefined): string {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  }

  formatCurrency(amount: number, currency: string | undefined = 'USD'): string {
    if (!amount) return '-';
    return `${amount.toLocaleString()} ${currency || 'USD'}`;
  }

  calculatePaidPercentage(paid: number, total: number): string {
    if (!total || total === 0) return '0%';
    const percentage = (paid / total) * 100;
    return `${Math.round(percentage)}%`;
  }

  trackByInvoiceId(_index: number, invoice: Invoice): string {
    return invoice._id;
  }

  // Pagination helper methods
  getPageNumbers(): number[] {
    const pages: number[] = [];
    const maxPagesToShow = 5;
    const currentPage = this.paginationInfo.currentPage;
    const lastPage = this.paginationInfo.lastPage;

    let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
    let endPage = Math.min(lastPage, startPage + maxPagesToShow - 1);

    // Adjust start page if we're near the end
    if (endPage - startPage < maxPagesToShow - 1) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  }

  // Math helper for template
  get Math() {
    return Math;
  }

  // Initialize KTMenu instances
  private initializeMenus(): void {
    setTimeout(() => {
      if (typeof KTMenu !== 'undefined') {
        KTMenu.createInstances();
      }
    }, 100);
  }

  // Refresh menus after data load
  private refreshMenus(): void {
    setTimeout(() => {
      if (typeof KTMenu !== 'undefined') {
        KTMenu.createInstances();
      }
    }, 50);
  }

  invoiceStatus(invoiceId: string, status: string) {


    Swal.fire({
      title: `${status == "approved" ? "Un Approve" : "Approve"} Invoice?`,
      text: `Are you sure you want to ${status == "approved" ? "un approve" : "approve"} this invoice.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `Yes, ${status == "approved" ? "un approve" : "approve"} invoice!`,
      cancelButtonText: 'No, cancel',
      buttonsStyling: false,
      customClass: {
        confirmButton: 'btn fw-bold btn-primary',
        cancelButton: 'btn fw-bold btn-active-light-primary',
      },
    }).then((result) => {
      if (result.isConfirmed) {

        status = status == "approved" ? "pending" : "approved";
        this.invoiceService.UpdateData(invoiceId, { status }).subscribe({
          next: (response: any) => {
            if (response.status) {
              this.loadInvoices(this.currentPage);
            }
          },
          error: (error) => {
            console.error('Error updating invoice status:', error);
          }
        });
      }
    });



  }

  // Method to open invoice detail modal
  openInvoiceDetailModal(invoice: Invoice): void {
    this.selectedInvoiceForDetail = invoice;
    this.selectedInvoiceIdForDetail = invoice._id;

    // Open the modal using Bootstrap
    const modalElement = document.getElementById('kt_modal_invoice_detail');
    if (modalElement) {
      const modal = new (window as any).bootstrap.Modal(modalElement);
      modal.show();
    }
  }

  // Copy selected ISL numbers to clipboard
  copySelectedISL(): void {
    if (this.selectedInvoicesForCopy.length === 0) {
      return;
    }

    // Get car_no values for selected invoices
    const selectedCarNos = this.invoices
      .filter(invoice => this.selectedInvoicesForCopy.includes(invoice._id))
      .map(invoice => invoice.vehicle?.car_no)
      .filter(carNo => carNo) // Remove empty values
      .join(',');

    if (selectedCarNos) {
      // Copy to clipboard
      navigator.clipboard.writeText(selectedCarNos).then(() => {
        // Show success message
        console.log('ISL numbers copied to clipboard:', selectedCarNos);
        alert(`${this.selectedInvoicesForCopy.length} ISL numbers copied to clipboard!`);
      }).catch(err => {
        console.error('Failed to copy to clipboard:', err);
        alert('Failed to copy to clipboard. Please try again.');
      });
    } else {
      alert('No ISL numbers found for selected invoices.');
    }
  }

  // Checkbox selection methods for ISL copy
  toggleInvoiceSelection(invoiceId: string, event: any): void {
    if (event.target.checked) {
      if (!this.selectedInvoicesForCopy.includes(invoiceId)) {
        this.selectedInvoicesForCopy.push(invoiceId);
      }
    } else {
      this.selectedInvoicesForCopy = this.selectedInvoicesForCopy.filter(id => id !== invoiceId);
    }

    // After selection changes, pre-select documents based on ship_type
    this.preselectDocumentsBasedOnShipType();
  }

  isInvoiceSelectedForCopy(invoiceId: string): boolean {
    return this.selectedInvoicesForCopy.includes(invoiceId);
  }

  isAllSelectedForCopy(): boolean {
    return this.invoices.length > 0 && this.selectedInvoicesForCopy.length === this.invoices.length;
  }

  isIndeterminateForCopy(): boolean {
    return this.selectedInvoicesForCopy.length > 0 && this.selectedInvoicesForCopy.length < this.invoices.length;
  }

  toggleSelectAllForCopy(event: any): void {
    if (event.target.checked) {
      this.selectedInvoicesForCopy = this.invoices.map(invoice => invoice._id);
    } else {
      this.selectedInvoicesForCopy = [];
    }

    // After selection changes, pre-select documents based on ship_type
    this.preselectDocumentsBasedOnShipType();
  }

  // Pre-select documents based on ship_type of selected invoices
  preselectDocumentsBasedOnShipType(): void {
    // Clear document selection first
    this.selectedDocumentTypes = [];

    // If no invoices selected, return
    if (this.selectedInvoicesForCopy.length === 0) {
      return;
    }

    // Get selected invoices data
    const selectedInvoicesData = this.invoices.filter(invoice =>
      this.selectedInvoicesForCopy.includes(invoice._id)
    );

    // Extract ship_types from selected invoices
    const shipTypes = selectedInvoicesData.map(invoice => invoice.order?.ship_type);
    const uniqueShipTypes = [...new Set(shipTypes.filter(type => type))]; // Remove null/undefined and get unique values

    // If all selected invoices have the same ship_type, pre-select documents
    if (uniqueShipTypes.length === 1) {
      const shipType = uniqueShipTypes[0];

      if (shipType === 'Roro') {
        // For Roro: Invoice, Export Certificate, Shipping Instruction
        this.selectedDocumentTypes = [
          'plain_invoice',
          'vehicle-certificate-invoice',
          'shipping_information'
        ];
      } else if (shipType === 'Container') {
        // For Container: Invoice, CTN Invoice Excel, Export Certificate
        this.selectedDocumentTypes = [
          'plain_invoice',
          'ctn_invoice_excel',
          'vehicle-certificate-invoice'
        ];
      }
    }
  }

  // Send mail method for selected invoices
  sendMailForSelected(): void {
    if (this.selectedInvoicesForCopy.length === 0) {
      Swal.fire({
        title: 'No Selection',
        text: 'Please select at least one invoice to send mail.',
        icon: 'warning',
        confirmButtonText: 'OK'
      });
      return;
    }

    // Get selected invoices data
    const selectedInvoicesData = this.invoices.filter(invoice =>
      this.selectedInvoicesForCopy.includes(invoice._id)
    );

    // Validate that all selected invoices have a ship_id
    const recordsWithoutShip = selectedInvoicesData.filter(invoice => !invoice.ship_id);

    if (recordsWithoutShip.length > 0) {
      Swal.fire({
        title: 'Validation Error',
        text: `${recordsWithoutShip.length} selected record(s) are missing Ship assignment. All records must have a Ship assigned.`,
        icon: 'error',
        confirmButtonText: 'OK'
      });
      return;
    }

    // Validate that all selected invoices have the same ship_id
    const shipIds = selectedInvoicesData.map(invoice => invoice.ship_id);
    const uniqueShipIds = [...new Set(shipIds)];

    if (uniqueShipIds.length > 1) {
      Swal.fire({
        title: 'Validation Error',
        text: 'All selected shipping records must have the same Ship ID.',
        icon: 'error',
        confirmButtonText: 'OK'
      });
      return;
    }

    const data = {
      invoice_ids: this.selectedInvoicesForCopy
    };

    this.isSendingMail = true;

    this.subscriptions.push(
      this.invoiceService.SendMail(data).subscribe({
        next: (response: any) => {
          this.isSendingMail = false;
          if (response.status) {
            Swal.fire({
              title: 'Success!',
              text: `Mail sent successfully for ${this.selectedInvoicesForCopy.length} invoice(s).`,
              icon: 'success',
              confirmButtonText: 'OK'
            }).then(() => {
              // Clear selections after successful send
              this.selectedInvoicesForCopy = [];
            });
          } else {
            Swal.fire({
              title: 'Error!',
              text: response.message || 'Failed to send mail.',
              icon: 'error',
              confirmButtonText: 'OK'
            });
          }
        },
        error: (error: any) => {
          this.isSendingMail = false;
          console.error('Error sending mail:', error);
          Swal.fire({
            title: 'Error!',
            text: 'An error occurred while sending mail.',
            icon: 'error',
            confirmButtonText: 'OK'
          });
        }
      })
    );
  }

  // Form data management methods
  private initializeFormData(): void {
    this.formData = {};
    this.invoices.forEach(invoice => {
      this.formData[invoice._id] = {
        ar: invoice.shipping_info?.ar || false,
        book_request_date: invoice.shipping_info?.book_request_date || '',
        ship_confirm_date: invoice.shipping_info?.ship_confirm_date || '',
        status: invoice.shipping_info?.status || '',
        terms: invoice.order?.total_type || '',
        container_no: invoice.shipping_info?.container_no || '',
        bl_number: invoice.shipping_info?.bl_number || '',
        vanning: invoice.shipping_info?.vanning || '',
        seal_number: invoice.shipping_info?.seal_number || '',
        shipping_mark: invoice.shipping_info?.shipping_mark || '',
        remark: invoice.shipping_info?.remark || ''
      };
    });
  }

  // Helper methods for form data access
  getFormValue(invoiceId: string, field: string): any {
    return this.formData[invoiceId]?.[field] || '';
  }

  setFormValue(invoiceId: string, field: string, value: any): void {
    if (!this.formData[invoiceId]) {
      this.formData[invoiceId] = {};
    }
    this.formData[invoiceId][field] = value;
    this.onFieldChange(invoiceId, field, value);
  }

  onFieldChange(invoiceId: string, field: string, value: any): void {
    if (!this.formData[invoiceId]) {
      this.formData[invoiceId] = {};
    }

    this.formData[invoiceId][field] = value;

    // Check if this invoice is already in changed rows
    const existingIndex = this.changedRows.findIndex(row => row.invoice_id === invoiceId);

    if (existingIndex >= 0) {
      // Update existing changed row
      this.changedRows[existingIndex] = {
        invoice_id: invoiceId,
        shipping_info: { ...this.formData[invoiceId] }
      };
    } else {
      // Add new changed row
      this.changedRows.push({
        invoice_id: invoiceId,
        shipping_info: { ...this.formData[invoiceId] }
      });
    }

    this.hasChanges = this.changedRows.length > 0;
  }

  onSave(): void {
    if (this.changedRows.length === 0) {
      return;
    }

    const changedCount = this.changedRows.length;

    console.log('Saving changes for invoices:', this.changedRows);

    // Show loading state
    this.isLoading = true;

    // Call the UpdateDataValue method with the changed rows
    this.subscriptions.push(
      this.invoiceService.UpdateDataValue({ data: this.changedRows }).subscribe({
        next: (response: any) => {
          console.log('Update response:', response);
          this.isLoading = false;

          if (response.status) {
            // Success - show success message
            Swal.fire({
              text: `Successfully updated ${changedCount} invoice(s)!`,
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "Ok, got it!",
              customClass: {
                confirmButton: "btn btn-primary"
              }
            });

            // Reset the changes after successful save
            this.hasChanges = false;
            this.changedRows = [];
            this.formData = {};

            // Optionally reload the data to reflect changes
            this.loadInvoices(this.currentPage);
          } else {
            // Handle API error response
            Swal.fire({
              text: response.message || "Failed to update invoices. Please try again.",
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Ok",
              customClass: {
                confirmButton: "btn btn-primary"
              }
            });
          }
        },
        error: (error) => {
          console.error('Error updating invoices:', error);
          this.isLoading = false;

          // Show error message
          Swal.fire({
            text: "An error occurred while updating invoices. Please try again.",
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Ok",
            customClass: {
              confirmButton: "btn btn-primary"
            }
          });
        }
      })
    );
  }

  // Click handlers for icons
  onDocsClick(vehicleId: string): void {
    console.log('Docs clicked for vehicle:', vehicleId);

    if (vehicleId) {
      // Find the vehicle object from the invoice
      const invoice = this.invoices.find(inv => inv.vehicle?._id === vehicleId);
      const vehicle = invoice?.vehicle;

      console.log('Found invoice:', invoice);
      console.log('Found vehicle:', vehicle);

      if (vehicle) {
        // Ensure the vehicle object has all required properties for the modal
        const vehicleForModal = {
          ...vehicle,
          // Map properties to what the modal expects
          stock_no: vehicle.car_no || vehicle.inventory_no,
          chassis_no: vehicle.vin_no || vehicle.chassis_no,
          // Ensure these properties exist
          make: vehicle.make || vehicle.company_name || '',
          model: vehicle.model || vehicle.name || '',
          year: vehicle.year || '',
          pictures: vehicle.pictures || []
        };

        console.log('Vehicle for modal:', vehicleForModal);

        // Set the selected vehicle for the modal
        (window as any).selectedVehicleForDocuments = vehicleForModal;

        // Open the vehicle upload documents modal
        const modalElement = document.getElementById('kt_modal_vehicle_upload_documents');
        if (modalElement) {
          try {
            const modal = new bootstrap.Modal(modalElement);
            modal.show();
            console.log('Vehicle upload documents modal opened successfully');
          } catch (error) {
            console.error('Error opening vehicle upload documents modal:', error);
          }
        } else {
          console.error('Vehicle upload documents modal element not found');
        }
      } else {
        console.error('Vehicle not found for ID:', vehicleId);
      }
    }
  }

  onOceanFreightClick(invoiceId: string): void {
    console.log('Ocean freight clicked for invoice:', invoiceId);

    if (invoiceId) {
      // Find the invoice and its vehicle
      const invoice = this.invoices.find(inv => inv._id === invoiceId);
      const vehicle = invoice?.vehicle;

      console.log('Found invoice for price sheet:', invoice);
      console.log('Found vehicle for price sheet:', vehicle);

      if (vehicle) {
        // Ensure the vehicle object has all required properties for the price sheet modal
        const vehicleForModal = {
          ...vehicle,
          // Map properties to what the modal expects
          stock_no: vehicle.car_no || vehicle.inventory_no,
          chassis_no: vehicle.vin_no || vehicle.chassis_no,
          // Ensure these properties exist
          make: vehicle.make || vehicle.company_name || '',
          model: vehicle.model || vehicle.name || '',
          year: vehicle.year || '',
          pictures: vehicle.pictures || []
        };

        console.log('Vehicle for price sheet modal:', vehicleForModal);

        // Set the selected vehicle for the price sheet modal
        (window as any).selectedVehicleForPriceSheet = vehicleForModal;

        // Open the vehicle price sheet modal
        const modalElement = document.getElementById('kt_modal_vh_price_sheet');
        if (modalElement) {
          try {
            const modal = new bootstrap.Modal(modalElement);
            modal.show();
            console.log('Vehicle price sheet modal opened successfully');
          } catch (error) {
            console.error('Error opening vehicle price sheet modal:', error);
          }
        } else {
          console.error('Vehicle price sheet modal element not found');
        }
      } else {
        console.error('Vehicle not found for invoice ID:', invoiceId);
      }
    }
  }

  // Open masho manager modal
  openMashoModal(vehicle: any): void {
    if (vehicle && vehicle._id) {
      console.log('Opening masho modal for vehicle:', vehicle);

      // Set the pre-selected vehicle in the modal service
      this._mashoManagerModalService.setPreSelectedVehicle(vehicle);

      // Open the masho manager add/edit modal
      const modalElement = document.getElementById('kt_modal_masho_manager_add_edit');
      if (modalElement) {
        try {
          const modal = new bootstrap.Modal(modalElement);
          modal.show();
          console.log('Masho manager modal opened successfully');
        } catch (error) {
          console.error('Error opening masho manager modal:', error);
        }
      } else {
        console.error('Masho manager modal element not found');
      }
    } else {
      console.error('Invalid vehicle data for masho modal');
    }
  }

  // Filter methods
  toggleFilters(): void {
    this.showFilters = !this.showFilters;
  }

  hasActiveFilters(): boolean {
    return Object.values(this.filters).some(value => value !== '' && value !== null && value !== undefined);
  }

  getActiveFiltersCount(): number {
    return Object.values(this.filters).filter(value => value !== '' && value !== null && value !== undefined).length;
  }

  clearFilters(): void {
    this.filters = {};
    this.clearShipSearch();
    this.clearClientSearch();
    this.clearSalesPersonSearch();
    this.ports = [];
    this.applyFilters();
  }

  applyFilters(): void {
    // Set IDs for ship, client, and sales person
    if (this.filters.ship_name) {
      this.filters.ship_name_id = this.filters.ship_name._id;
    }
    if (this.filters.search_client) {
      this.filters.search_client_id = this.filters.search_client._id;
    }
    if (this.filters.sales_person) {
      this.filters.sales_person_id = this.filters.sales_person._id;
    }

    console.log('Applied filters:', this.filters);
    this.loadInvoices(1, this.searchTerm, this.filters);
  }

  // Data loading methods
  loadCountries(): void {
    this.subscriptions.push(
      this.globalStateService.GetCountries().subscribe({
        next: (countries: any) => {
          this.countries = countries || [];
        },
        error: (error: any) => {
          console.error('Error loading countries:', error);
        }
      })
    );
  }

  loadYards(): void {
    this.subscriptions.push(
      this.vendorService.GetData('1', '', { type: 'yard', paginate: false }).subscribe({
        next: (response: any) => {
          if (response.status && response.data) {
            this.yards = response.data.data || response.data || [];
          }
        },
        error: (error: any) => {
          console.error('Error loading yards:', error);
          this.yards = [];
        }
      })
    );
  }

  onDestinationCountryChange(countryCode: string | undefined): void {
    if (countryCode) {
      this.loadPorts(countryCode);
      this.filters.destination_country_label = this.countries.find(country => country.code === countryCode)?.name || '';
    } else {
      this.ports = [];
      this.filters.destination_port = '';
      this.filters.destination_country_label = '';
    }
  }

  private loadPorts(countryCode: string): void {
    if (!countryCode) {
      this.ports = [];
      return;
    }

    this.isLoadingPorts = true;
    this.subscriptions.push(
      this.portService.GetData('1', '', { paginate: false, country_code: countryCode }).subscribe({
        next: (response: any) => {
          if (response.status) {
            this.ports = response.data || [];
          } else {
            this.ports = [];
          }
          this.isLoadingPorts = false;
        },
        error: (error: any) => {
          console.error('Error loading ports:', error);
          this.ports = [];
          this.isLoadingPorts = false;
        }
      })
    );
  }

  // Ship search methods
  private setupShipSearchDebounce(): void {
    this.shipSearchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(searchTerm => {
      this.searchShips(searchTerm);
    });
  }

  onShipSearchInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.shipSearchTerm = target.value;
    this.selectedShip = null;
    this.shipSearchSubject.next(this.shipSearchTerm);
    this.showShipDropdown = true;
  }

  private searchShips(searchTerm: string): void {
    if (!searchTerm || searchTerm.length < 2) {
      this.shipSearchResults = [];
      this.showShipDropdown = false;
      return;
    }

    this.isShipSearching = true;
    this.subscriptions.push(
      this.shipService.GetData('1', searchTerm).subscribe({
        next: (response: PaginatedResponse<any>) => {
          this.isShipSearching = false;
          if (response.status && response.data && response.data.data) {
            this.shipSearchResults = response.data.data;
            this.showShipDropdown = this.shipSearchResults.length > 0;
          } else {
            this.shipSearchResults = [];
            this.showShipDropdown = false;
          }
        },
        error: (error: any) => {
          this.isShipSearching = false;
          console.error('Error searching ships:', error);
          this.shipSearchResults = [];
          this.showShipDropdown = false;
        }
      })
    );
  }

  selectShip(ship: any): void {
    this.selectedShip = ship;
    this.shipSearchTerm = this.getShipDisplayName(ship);
    this.showShipDropdown = false;
    this.shipSearchResults = [];
    this.filters.ship_name = ship;
  }

  clearShipSearch(): void {
    this.shipSearchTerm = '';
    this.selectedShip = null;
    this.showShipDropdown = false;
    this.shipSearchResults = [];
    this.filters.ship_name = null;
  }

  onShipInputFocus(): void {
    if (this.shipSearchResults.length > 0) {
      this.showShipDropdown = true;
    }
  }

  onShipInputBlur(): void {
    setTimeout(() => {
      this.showShipDropdown = false;
    }, 200);
  }

  getShipDisplayName(ship: any): string {
    return `${ship.ship_id || ''}, ${ship.name || ''} - ${ship.company || ''} (${ship.voyage_no || ''})`;
  }

  // Client search methods
  private setupClientSearchDebounce(): void {
    this.clientSearchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(searchTerm => {
      this.searchClients(searchTerm);
    });
  }

  onClientSearchInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.clientSearchTerm = target.value;
    this.selectedClient = null;
    this.clientSearchSubject.next(this.clientSearchTerm);
    this.showClientDropdown = true;
  }

  private searchClients(searchTerm: string): void {
    if (!searchTerm || searchTerm.length < 2) {
      this.clientSearchResults = [];
      this.showClientDropdown = false;
      return;
    }

    this.isClientSearching = true;
    this.subscriptions.push(
      this.clientService.GetData('1', searchTerm).subscribe({
        next: (response: any) => {
          this.isClientSearching = false;
          if (response.status && response.data && response.data.data) {
            this.clientSearchResults = response.data.data;
            this.showClientDropdown = this.clientSearchResults.length > 0;
          } else {
            this.clientSearchResults = [];
            this.showClientDropdown = false;
          }
        },
        error: (error: any) => {
          this.isClientSearching = false;
          console.error('Error searching clients:', error);
          this.clientSearchResults = [];
          this.showClientDropdown = false;
        }
      })
    );
  }

  selectClient(client: any): void {
    this.selectedClient = client;
    this.clientSearchTerm = this.getClientDisplayName(client);
    this.showClientDropdown = false;
    this.clientSearchResults = [];
    this.filters.search_client = client;
  }

  clearClientSearch(): void {
    this.clientSearchTerm = '';
    this.selectedClient = null;
    this.showClientDropdown = false;
    this.clientSearchResults = [];
    this.filters.search_client = null;
  }

  onClientInputFocus(): void {
    if (this.clientSearchResults.length > 0) {
      this.showClientDropdown = true;
    }
  }

  onClientInputBlur(): void {
    setTimeout(() => {
      this.showClientDropdown = false;
    }, 200);
  }

  getClientDisplayName(client: any): string {
    if (client.name && client.company) {
      return `${client.name}, ${client.company}, ${client.currency_type}`;
    }
    return `${client.name || ''} ${client.last_name || ''}`.trim() || client.email || 'Unknown Client';
  }

  // Sales person search methods
  private setupSalesPersonSearchDebounce(): void {
    this.salesPersonSearchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(searchTerm => {
      this.searchSalesPersons(searchTerm);
    });
  }

  onSalesPersonSearchInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.salesPersonSearchTerm = target.value;
    this.selectedSalesPerson = null;
    this.salesPersonSearchSubject.next(this.salesPersonSearchTerm);
    this.showSalesPersonDropdown = true;
  }

  private searchSalesPersons(searchTerm: string): void {
    if (!searchTerm || searchTerm.length < 2) {
      this.salesPersonSearchResults = [];
      this.showSalesPersonDropdown = false;
      return;
    }

    this.isSalesPersonSearching = true;
    this.subscriptions.push(
      this.userService.GetData('1', searchTerm, { is_primary_agent: true }).subscribe({
        next: (response: any) => {
          this.isSalesPersonSearching = false;
          if (response.status && response.data && response.data.data) {
            this.salesPersonSearchResults = response.data.data;
            this.showSalesPersonDropdown = this.salesPersonSearchResults.length > 0;
          } else {
            this.salesPersonSearchResults = [];
            this.showSalesPersonDropdown = false;
          }
        },
        error: (error: any) => {
          this.isSalesPersonSearching = false;
          console.error('Error searching sales persons:', error);
          this.salesPersonSearchResults = [];
          this.showSalesPersonDropdown = false;
        }
      })
    );
  }

  selectSalesPerson(salesPerson: any): void {
    this.selectedSalesPerson = salesPerson;
    this.salesPersonSearchTerm = this.getSalesPersonDisplayName(salesPerson);
    this.showSalesPersonDropdown = false;
    this.salesPersonSearchResults = [];
    this.filters.sales_person = salesPerson;
  }

  clearSalesPersonSearch(): void {
    this.salesPersonSearchTerm = '';
    this.selectedSalesPerson = null;
    this.showSalesPersonDropdown = false;
    this.salesPersonSearchResults = [];
    this.filters.sales_person = null;
  }

  onSalesPersonInputFocus(): void {
    if (this.salesPersonSearchResults.length > 0) {
      this.showSalesPersonDropdown = true;
    }
  }

  onSalesPersonInputBlur(): void {
    setTimeout(() => {
      this.showSalesPersonDropdown = false;
    }, 200);
  }

  getSalesPersonDisplayName(salesPerson: any): string {
    if (salesPerson.name && salesPerson.company) {
      return `${salesPerson.name}, ${salesPerson.company}, ${salesPerson.currency_type}`;
    }
    return `${salesPerson.name || ''} ${salesPerson.last_name || ''}`.trim() || salesPerson.email || 'Unknown Sales Person';
  }

  // Export Excel method
  exportExcel(): void {
    this.isExportingExcel = true;

    const filtersObj =  this.hasActiveFilters() ? this.filters : {}

    // Prepare the request body
    const requestBody = {
      ...filtersObj,
      type: 'invoice',
      invoice_type: 'shipping',
      excel_name: 'Shipping Report',
      shipping_status: this.selectedStatus,
      ship_type: this.selectedSubFilter,
      freight_paid_type: this.selectedFreightPaidSubFilter
    };

    this.subscriptions.push(
      this.generalService.generateExcelPost(requestBody).subscribe({
        next: (response: any) => {
          this.isExportingExcel = false;
          console.log('Excel export response:', response);

          if (response.status && response.data && response.data.url) {
            // Open the Excel file URL in a new tab
            window.open(response.data.url, '_blank');
          } else {
            // Show error message if no URL is returned
            Swal.fire({
              text: 'Failed to generate Excel file. No URL received.',
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Ok, got it!",
              customClass: {
                confirmButton: "btn fw-bold btn-primary",
              }
            });
          }
        },
        error: (error: any) => {
          this.isExportingExcel = false;
          console.error('Error exporting Excel:', error);
          Swal.fire({
            text: 'An error occurred while exporting Excel file.',
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn fw-bold btn-primary",
            }
          });
        }
      })
    )
  }

  // Open export fields modal
  openExportFieldsModal(): void {
    const modalElement = document.getElementById('kt_modal_shipping_export_fields');
    if (modalElement) {
      try {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
        console.log('Export fields modal opened successfully');
      } catch (error) {
        console.error('Error opening export fields modal:', error);
      }
    } else {
      console.error('Export fields modal element not found');
    }
  }

  // Export Excel with selected fields
  exportExcelWithSelectedFields(selectedFields: string[]): void {
    this.isExportingSelectedFields = true;

    const filtersObj = this.hasActiveFilters() ? this.filters : {};

    // Prepare the request body with selected fields
    const requestBody = {
      ...filtersObj,
      type: 'invoice',
      invoice_type: 'shipping',
      excel_name: 'Shipping Report',
      selected_fields: selectedFields,
      shipping_status: this.selectedStatus,
      ship_type: this.selectedSubFilter,
      freight_paid_type: this.selectedFreightPaidSubFilter
    };

    console.log('Exporting Excel with selected fields:', requestBody);

    this.subscriptions.push(
      this.generalService.generateExcelPost(requestBody).subscribe({
        next: (response: any) => {
          this.isExportingSelectedFields = false;
          console.log('Excel export response:', response);

          if (response.status && response.data && response.data.url) {
            // Open the Excel file URL in a new tab
            window.open(response.data.url, '_blank');

            // Show success message
            Swal.fire({
              text: 'Excel file has been generated successfully!',
              icon: 'success',
              buttonsStyling: false,
              confirmButtonText: 'Ok, got it!',
              customClass: {
                confirmButton: 'btn btn-primary'
              }
            });
          } else {
            // Show error message if no URL is returned
            Swal.fire({
              text: 'Failed to generate Excel file. No URL received.',
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Ok, got it!",
              customClass: {
                confirmButton: "btn fw-bold btn-primary",
              }
            });
          }
        },
        error: (error: any) => {
          this.isExportingSelectedFields = false;
          console.error('Error exporting Excel:', error);
          Swal.fire({
            text: 'An error occurred while exporting Excel file.',
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn fw-bold btn-primary",
            }
          });
        }
      })
    )
  }

  getInvoiceStatus(invoice: Invoice): string {
    return this.helperService.getInvoiceStatus(invoice, this.currentDate);
  }

  getAge(invoice: Invoice): string {
    return this.helperService.getAge(invoice, this.currentDate);
  }

  // Toggle document type selection
  toggleDocumentType(documentType: string): void {
    const index = this.selectedDocumentTypes.indexOf(documentType);
    if (index > -1) {
      this.selectedDocumentTypes.splice(index, 1);
    } else {
      this.selectedDocumentTypes.push(documentType);
    }
  }

  // Check if document type is selected
  isDocumentTypeSelected(documentType: string): boolean {
    return this.selectedDocumentTypes.includes(documentType);
  }

  // Open send shipping mail modal
  openSendShippingMailModal(): void {
    if (this.selectedInvoicesForCopy.length === 0) {
      Swal.fire({
        title: 'No Selection',
        text: 'Please select at least one shipping record to send mail.',
        icon: 'warning',
        confirmButtonText: 'OK'
      });
      return;
    }

    if (this.selectedDocumentTypes.length === 0) {
      Swal.fire({
        title: 'No Document Type Selected',
        text: 'Please select at least one document type to send.',
        icon: 'warning',
        confirmButtonText: 'OK'
      });
      return;
    }

    // Get selected invoices data
    const selectedInvoicesData = this.invoices.filter(invoice =>
      this.selectedInvoicesForCopy.includes(invoice._id)
    );

    // Validate that all selected invoices have the same ship_type
    const shipTypes = selectedInvoicesData.map(invoice => invoice.order?.ship_type);
    const uniqueShipTypes = [...new Set(shipTypes.filter(type => type))]; // Remove null/undefined and get unique values

    if (uniqueShipTypes.length > 1) {
      Swal.fire({
        title: 'Validation Error',
        text: 'Selected records have different ship_type.',
        icon: 'error',
        confirmButtonText: 'OK'
      });
      return;
    }

    // Validate that all selected invoices have a ship_id
    const recordsWithoutShip = selectedInvoicesData.filter(invoice => !invoice.ship_id);

    if (recordsWithoutShip.length > 0) {
      Swal.fire({
        title: 'Validation Error',
        text: `${recordsWithoutShip.length} selected record(s) are missing Ship assignment. All records must have a Ship assigned.`,
        icon: 'error',
        confirmButtonText: 'OK'
      });
      return;
    }

    // Validate that all selected invoices have the same ship_id
    const shipIds = selectedInvoicesData.map(invoice => invoice.ship_id);
    const uniqueShipIds = [...new Set(shipIds)];

    if (uniqueShipIds.length > 1) {
      Swal.fire({
        title: 'Validation Error',
        text: 'All selected shipping records must have the same Ship ID.',
        icon: 'error',
        confirmButtonText: 'OK'
      });
      return;
    }

    // Prepare data for modal
    (window as any).selectedShippingsForMail = {
      invoices: selectedInvoicesData,
      documentTypes: this.selectedDocumentTypes
    };

    // Open the modal
    const modalElement = document.getElementById('kt_modal_send_shipping_mail');
    if (modalElement) {
      try {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
        console.log('Send shipping mail modal opened successfully');
      } catch (error) {
        console.error('Error opening send shipping mail modal:', error);
      }
    } else {
      console.error('Send shipping mail modal element not found');
    }
  }

  getAgentNotes(invoice:Invoice){

    let notes = invoice.shipping_info?.agent_notes;

    if(!notes || notes.length < 20){
      return notes;
    }

    return notes.substring(0,20)+"...";

  }

  viewDetailClient(client_id: any): void {
    if (client_id) {
      const url = this._router.serializeUrl(
        this._router.createUrlTree(['sales/client-manager', client_id])
      );

      window.open(url, '_blank');
    }
  }

}
